export default __webpack_public_path__ + "static/media/qr-alipay.55c831f0.png";